// Lib
import React, { ReactElement } from 'react';

// Utils
import { getGroupUnseen } from '../groups/notificationGroupUtils';

// Components
import NotificationGroup from './group/NotificationGroup';
import NotificationShowMoreButton from './NotificationShowMoreButton';
import StyledButton from '../../../../../components/buttons/StyledButton';
import FloatingButtonContainer from '../../../../../components/popupPanel/FloatingButtonContainer';

export interface NotificationsListProps {
    dispatchMarkAllNotificationsAsSeen: () => void;
    notificationGroups: any[];
    hasMore: boolean;
    isNotificationsSheetOpen: boolean;
    isMobileAppMode: boolean;
}

const NotificationsList = (props: NotificationsListProps): ReactElement => {
    const { notificationGroups, dispatchMarkAllNotificationsAsSeen, isNotificationsSheetOpen, isMobileAppMode } = props;

    const hasUnseenNotifications = notificationGroups?.some(getGroupUnseen);

    // dont show if notifications sheet is not open for mobile
    const showMarkAllButton = (!isMobileAppMode || isNotificationsSheetOpen) && hasUnseenNotifications;

    return (
        <>
            {notificationGroups.map((group, index) => (
                <NotificationGroup {...props} key={index} group={group} />
            ))}
            <NotificationShowMoreButton {...props} />
            {showMarkAllButton && (
                <FloatingButtonContainer>
                    <StyledButton className="secondary thin" onClick={dispatchMarkAllNotificationsAsSeen}>
                        Mark all as seen
                    </StyledButton>
                </FloatingButtonContainer>
            )}
        </>
    );
};

export default NotificationsList;
